import React from 'react';
import css from './styles.module.scss';
import { Card, CardHeader, Grid, GridProps } from '@material-ui/core';
import AvatarGroup from '@material-ui/lab/AvatarGroup';
import Avatar from '@material-ui/core/Avatar';

type Props = GridProps & {
    title: string;
    avatar?: string;
};

export const ContactCompanyCard: React.FC<Props> = ({ title, avatar, ...props }) => {
    return (
        <Grid item xs={12} {...props}>
            <Card elevation={0} className={css.contactCard}>
                <CardHeader
                    className={css.contactCardHeader}
                    avatar={
                        <AvatarGroup>
                            <Avatar
                                variant="square"
                                className={css.avatar}
                                alt={title}
                                src={avatar}
                            />
                        </AvatarGroup>
                    }
                    title={title}
                />
            </Card>
        </Grid>
    );
};
